import React, { Component } from 'react'

import PropTypes from 'prop-types'
import {colors} from "./../../cc-imports";

class CCActivityIndicator extends Component {

    static propTypes = {
        size : PropTypes.string,
        isButton: PropTypes.bool,
        color : PropTypes.string
    }

    static defaultProps = {
        size : 'l',
        isButton : false,
        color : colors.theme2.font_color4
    }

    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        let isButton = this.props.isButton == true;
        if(isButton){
            return (
                <div className={"loader-"+this.props.size}> </div>
            )
        }
        else {
            return (
                <div className={"loader-"+this.props.size}>

                </div>
            )
        }

    }
}

export default CCActivityIndicator


// WEBPACK FOOTER //
// ./src/app/components/CCActivityIndicator/CCActivityIndicator.js